import './SocialEmbed.scss';

import {
  FacebookEmbed,
  InstagramEmbed,
  TikTokEmbed,
} from 'react-social-media-embed';
import { ClientOnly } from 'remix-utils/client-only';

import { YouTubeEmbedWrapper } from '../YouTubeEmbedWrapper';

const className = 'c-SocialEmbed';

export const SocialEmbed = ({ type, url }: { type: string; url: string }) => {
  switch (type) {
    case 'instagram':
      return (
        <ClientOnly>
          {() => (
            <InstagramEmbed
              url={url}
              placeholderDisabled
              className={className}
            />
          )}
        </ClientOnly>
      );
    case 'facebook':
      return (
        <ClientOnly>
          {() => (
            <FacebookEmbed
              url={url}
              placeholderDisabled
              className={className}
            />
          )}
        </ClientOnly>
      );
    case 'tiktok':
      return (
        <ClientOnly>
          {() => (
            <div className={`${className}__tiktok-container`}>
              <TikTokEmbed
                url={url}
                width={325}
                placeholderDisabled
                className={className}
              />
            </div>
          )}
        </ClientOnly>
      );
    case 'youtube':
      return <ClientOnly>{() => <YouTubeEmbedWrapper url={url} />}</ClientOnly>;
    default:
      return null;
  }
};
